<template>
  <header class="header-nav-box opacity" v-if="headerShow === true">
    <div class="header-nav-box-in" >
        <div class="logo" ><img src="../assets/logo.png"/></div> 
        <div class="topbar-right">  
          <!-- <router-link to="/" class="stay-action">首页</router-link>
          <router-link to="/product">产品中心</router-link>
          <router-link to="/login">用户中心</router-link> -->
          <!-- <router-link to="/user">
            <a-button type="link">登录</a-button>
          </router-link> -->
          <!-- <router-link :to="{ name: 'pageA', params: { id: Id}}" tag="a" target="_blank">新页面</router-link> -->
          <a-space>
            <a-menu v-model:selectedKeys="current" mode="horizontal" style="line-height:80px;font-size:18px;border:none;" :items="items"/>
            <!--登录之前的展示-->
            <!-- <a-button @click="openNewPageLogin()" type="text" shape="round"  >登录</a-button>
            <a-button @click="zhucePage()" type="primary" shape="round" >注册</a-button> -->
            <!--登录之后的展示-->
            <a-flex v-if="username !== ''" style="margin-left: 120px;" gap="10">
              <img src="../assets/usericon.png" class="usericon"/>
              <span>{{username}}</span>
              <a @click="fixpassword()" type="text" >修改密码</a>
              <span>邀请码: {{ yqm }}</span>
              <a @click="loginOut">退出</a>
              <a-modal v-model:open="open" title="" @ok="handleOk">
                <p>确认退出该账号？</p>
              </a-modal>
            </a-flex>
            <a-flex v-else style="margin-left: 120px;" gap="10" align="center">
              <a type="link" :onclick="openNewPageLogin">登录</a>
              <a-button type="primary" :onclick="zhucePage">免费注册</a-button>
            </a-flex>
          </a-space> 
        </div>
    </div>
    </header>
</template>
<script setup>
import { h, ref } from 'vue';
import { useRouter } from 'vue-router';
import {getAuthCache, delAuthCache, go} from "@/utils/utils";
import {TOKEN_KEY, USER_INFO_KEY} from "@/enums/cacheEnum";
import {useMessage} from "@/utils/useMessage";
import router from "@/router";
const { notification, createMessage,createConfirm } = useMessage();
const open = ref(false);
const headerShow = ref(true)
// let username = this.store.state.username
let username = ""
let yqm = ""
let userInfo = getAuthCache(USER_INFO_KEY)
let token = getAuthCache(TOKEN_KEY)
//判断uri， 部分页面刷新是不需要判断的
let arr = ['register', 'forgetPwd', 'forgetSmsCode', 'login', 'passwordSuccess']
let uri = window.location.pathname
uri = uri.split('/')

// if(undefined !== uri[1] && uri[1] !== ''){
//
// }
// console.log(token)
// console.log(userInfo)
if(!arr.includes(uri[1])){
  if('undefined' !== userInfo && 'undefined' !== token && userInfo && token){
    let info = JSON.parse(userInfo)
    username = info.zh
    yqm = info.yqm
  }else{
    // router.push({ name: 'login' })
    console.log( uri[1] )
    if(uri[1] === ''){
      //首页不跳转，但要显示用户信息
    }else{
      const routeUrl = router.resolve({ name: 'login' });
      window.open(routeUrl.href,'_self');
    }
  }
}else{
  if(!uri[1] === 'passwordSuccess'){
    headerShow.value = false
  }
}

const loginOut = () => {
  createConfirm({
    iconType: 'warning',
    title: '确认退出',
    content: '是否确认退出登录',
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      // return defHttp.delete({url: Api.deleteBatch, data: params}, {joinParamsToUrl: true}).then(() => {
      //   handleSuccess();
      // });
      delAuthCache(TOKEN_KEY)
      delAuthCache(USER_INFO_KEY)
      // username = ""
      window.location.href = "/"
    }
  });
};

const handleOk = e => {
  console.log(e);
  open.value = false;
};
//首页menu
// console.log(uri[1])

//判断是否为用户中心子菜单
let userChildMenu = ['remind', 'orderList', 'policy', 'claim', 'account', 'common', 'occupation', 'download']
const current = ref([uri[1]]);

if(userChildMenu.includes(uri[1])){
  current.value = ['remind']
}

const items = ref([
  {
    key: '',
    label: h(
      'a',
      {
        href: '/',
        //target: '_blank',
      },
      '首页',
    ), 
  },
  {
    key: 'product',
     label: h(
      'a',
      {
        href:'/product',
        //target: '_blank',
      },
      '产品中心',
    ), 
  },
  {
    key: 'remind',
     label: h(
      'a',
      {
        href:'/remind',
        //target: '_blank',
      },
      '用户中心',
    ), 
  },
  // {
  //   key: 'sells',
  //    label: h(
  //     'a',
  //     {
  //       href:'/sells',
  //       //target: '_blank',
  //     },
  //     '销售中心',
  //   ),
  // }
]);

</script>
<script>
export default {
  methods: {
    openNewPageLogin() {
      const routeUrl = this.$router.resolve({ name: 'login' });
      window.open(routeUrl.href,'_self');
    },
    zhucePage(){
      const routeUrl = this.$router.resolve({ name: 'register' });
      window.open(routeUrl.href,'_self');
    },
    fixpassword(){
      const routeUrl = this.$router.resolve({ name: 'fixpassword' });
      window.open(routeUrl.href,'_self');
    },
  }
}
</script>
<style> 
.ant-menu-light.ant-menu-horizontal >.ant-menu-item{margin-left:50px;}
</style>
<style scoped>
header{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 80px; 
  
}
.header-nav-box{
  height: 80px;  
  position: fixed; 
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%; 
  background: white;
}
.header-nav-box-in{
  width: 1200px;
  height: 80px;
  margin: 0 auto; 
}
.opacity{
  opacity: 0.8;
}
 
.topbar-right{ 
  height: 80px;
  float: right;
}
.logo {
  float: left;
  width: 200px; 
  margin-top: 20px;  
}

.usericon{
  width: 12px;
  height: 12px; 
}
</style>